import { SubText, WithTooltip } from '@procurify/ui'

import { useFormatPrice } from '@webapp/hooks'
import { OrderItemReceiveMethods } from '@webapp/models/enums'
import { type ColumnTypeData } from '../../types/DataTable.types'

export const ItemReceivedQuantityCell = ({
  receivedAmount,
  total,
  receiveMethod = OrderItemReceiveMethods.QUANTITY,
  currency,
  tooltipContent,
}: ColumnTypeData['ITEM_RECEIVED_QUANTITY']) => {
  const formatPrice = useFormatPrice()

  const content =
    receiveMethod === OrderItemReceiveMethods.CURRENCY_AMOUNT
      ? `${formatPrice(receivedAmount)} / ${formatPrice(total)}${
          currency ? ` ${currency}` : ''
        }`
      : `${receivedAmount} / ${total}`

  return (
    <WithTooltip
      isDisabled={!tooltipContent}
      title={tooltipContent}
      placement='top'
    >
      <WithTooltip.Wrapper>
        <SubText bold>{content}</SubText>
      </WithTooltip.Wrapper>
    </WithTooltip>
  )
}

ItemReceivedQuantityCell.displayName = 'ItemReceivedQuantityCell'
